import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class ViewportUpdateClassifier {
  constructor() {
    _defineProperty(this, "types", []);
    _defineProperty(this, "filters", []);
    _defineProperty(this, "removedFilters", []);
    _defineProperty(this, "__combinedTypes", []);
    _defineProperty(this, "__combinedFilters", []);
  }
  VCCalculationMethod(_) {
    return {
      VC: {},
      VCBox: {}
    };
  }

  // @todo remove it once fixed as described: https://product-fabric.atlassian.net/browse/AFO-3443
  filterComponentsLog({
    componentsLog
  }) {
    return componentsLog;
  }
  mergeConfig() {
    this.__combinedTypes = [...this.types, ...((this === null || this === void 0 ? void 0 : this.__combinedTypes) || [])];
    const previousFilters = this.removedFilters.length === 0 ? this.__combinedFilters : this.__combinedFilters.filter(filter => !this.removedFilters.includes(filter.name));
    this.__combinedFilters = [...this.filters, ...previousFilters];
  }
  classifyUpdate({
    element,
    type,
    tags,
    ignoreReason
  }) {
    if (!this.__combinedTypes.includes(type)) {
      return false;
    }
    return this.__combinedFilters.every(({
      filter,
      name
    }) => {
      return filter({
        type,
        tags,
        ignoreReason
      });
    });
  }
}